import React from "react";
import { PARENT_TYPES } from './form-constants';
import ControlledForm from "~/shared/form/ControlledForm";
import TextInput from "~/shared/form/TextInput";
import SelectInput from "~/shared/form/SelectInput";
import Page from "~/shared/Page";
import FormSection from "~/shared/form/FormSection";
import axios from "axios";
import FloatingPanel from "~/shared/FloatingPanel";
import { setUserAccountStatusOverride } from "~/shared/auth-utils";
import { AddressFields, EmergencyContactFields, FullNameFields } from "~/pages/family/FieldGroups";
import FormResponse from "~/shared/form/FormResponse";
import FormButton from "~/shared/form/FormButton";
import CheckboxInput from "~/shared/form/CheckboxInput";
import { Link } from "react-router-dom";

export default function ParentSetup() {
    async function defaultValues() {
        return (await axios.post("family/load-profile")).data.parent;
    }

    return (
        <Page title="Family Setup">
            <div className="page-container">
                <FloatingPanel title="Parent Information">
                    <ControlledForm options={{ defaultValues }} post="family/setup-parent" redirect="/setup/household" onSuccess={() => setUserAccountStatusOverride("Household Setup Pending")}>
                        <p className="mb-4">
                            Fill out your information below to create a parent profile.
                            Required fields are marked with a star (*).
                        </p>
                        <div className="flex flex-col gap-3">
                            <FormSection row wrap gap={1}>
                                <FullNameFields />
                            </FormSection>

                            <FormSection row wrap gap={1}>
                                <TextInput label="Phone Number" id="mainPhone" preset="phone" required />
                                <SelectInput label="Relationship" id="childRelationship" placeholder="Select relationship" options={PARENT_TYPES} required />
                            </FormSection>

                            <FormSection row wrap gap={1}>
                                <AddressFields />
                            </FormSection>
                            <CheckboxInput className="-mt-1 mb-2 text-sm" label={<>
                                By checking, you agree to receive transactional/informational text messages from Next Generation Focus with reminders and important updates regarding the programs your children are in at the phone number provided above.
                                Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to opt out. View our <Link to="/privacy">Privacy Policy</Link> and <Link to="/mobile-tos">Mobile Terms of Service</Link>.
                            </>} id="acceptSMS" />
                            <p className="text-center -mb-2">
                                You are required to enter two additional contacts in case you cannot be reached during an emergency.
                            </p>
                            <FormSection row wrap gap={1} title="Emergency Contact #1" heading>
                                <EmergencyContactFields family />
                            </FormSection>
                            <FormSection row wrap gap={1} title="Emergency Contact #2" heading>
                                <EmergencyContactFields family prefix="alt" />
                            </FormSection>
                        </div>
                        <br />
                        <FormResponse />
                        <FormButton className="mx-auto" family submit />
                    </ControlledForm>
                </FloatingPanel>
            </div>
        </Page>
    );
}
